module.exports = __webpack_public_path__ + "static/img/logo.d4953f7.gif";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo.gif
// module id = Zkwq
// module chunks = 12